var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8044 0.178505C13.8673 0.235593 13.9173 0.303473 13.9513 0.378241C13.9854 0.453008 14.0029 0.533189 14.0029 0.614167C14.0029 0.695145 13.9854 0.775325 13.9513 0.850093C13.9173 0.92486 13.8673 0.99274 13.8044 1.04983L7.48091 6.82235C7.35413 6.93755 7.18254 7.00221 7.00366 7.00221C6.82479 7.00221 6.65319 6.93755 6.52641 6.82235L0.20291 1.04983C0.0763369 0.934283 0.00522983 0.777571 0.00522984 0.614166C0.00522984 0.450761 0.076337 0.294049 0.20291 0.178504C0.329484 0.0629593 0.501154 -0.00195372 0.680156 -0.00195371C0.859158 -0.0019537 1.03083 0.0629593 1.1574 0.178504L6.4596 5.02852C6.60397 5.15928 6.7991 5.23264 7.00247 5.23264C7.20584 5.23264 7.40097 5.15928 7.54533 5.02852L12.8547 0.178505C12.9813 0.0630438 13.153 -0.00180691 13.3319 -0.00180691C13.5109 -0.0018069 13.6826 0.0630438 13.8092 0.178505",
    fill: "#2C2C2C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlack);
export default __webpack_public_path__ + "static/media/arrow_down_black.3732f25619c73dfb2373d6cd5e00cf8c.svg";
export { ForwardRef as ReactComponent };